export default "__VITE_ASSET__B0IMIm1T__"